// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.finance-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 20px;
}
.finance-form__row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}
.finance-form__field--select .finance-form__select-label {
  position: relative;
  display: block;
}
.finance-form__select-label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 13px;
  letter-spacing: 1.1px;
  color: #bbb7b7;
}
.finance-form__select-text {
  position: absolute;
  left: 23px;
  top: 3px;
  font-size: 13px;
}
.finance-form__type-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
}
.finance-form__type-tab--active {
  opacity: 1;
}
.finance-form__type-tab--active button, .finance-form__type-tab--active a {
  background: #f4f4f4;
}
.finance-form__type-tab--active button span, .finance-form__type-tab--active a span {
  color: #131313;
}
.finance-form__select {
  width: 100%;
  background: var(--primary-color);
  background: transparent;
  border-radius: 8.485px;
  background: var(--primary-color);
  border: 1px solid #2B2B2B;
  padding: 20px 50px 13px 23px;
  color: #F4F4F4;
  font-family: "Roboto", sans-serif;
  font-size: 13px;
  letter-spacing: 1.95px;
  outline: none;
  appearance: none;
}
.finance-form__actions {
  display: flex;
  gap: 12px;
  margin-top: 4px;
}
.finance-form__cancel {
  opacity: 0.8;
}
.finance-form__purchase-amount {
  position: relative;
}
.finance-form__purchase-amount input {
  padding-right: 56px;
}
.finance-form__purchase-amount-currency {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  font-size: 12px;
  z-index: 1;
}
@media (max-width: 1024px) {
  .finance-form__row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 600px) {
  .finance-form__row {
    grid-template-columns: minmax(0, 1fr);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/FinanceForm/FinanceForm.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AADF;AAEE;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AAAJ;AAKM;EACE,kBAAA;EACA,cAAA;AAHR;AAQE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;AANJ;AASE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,eAAA;AAPJ;AASE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AAPJ;AAUE;EACE,UAAA;AARJ;AASI;EACE,mBAAA;AAPN;AAQK;EACE,cAAA;AANP;AAWE;EACE,WAAA;EAEA,gCAAA;EACA,uBAAA;EACA,sBAAA;EACA,gCC3DG;ED4DH,yBAAA;EACA,4BAAA;EACA,cAAA;EACA,iCAAA;EACA,eAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;AAVJ;AAaE;EACE,aAAA;EACA,SAAA;EACA,eAAA;AAXJ;AAcE;EACE,YAAA;AAZJ;AAcE;EACE,kBAAA;AAZJ;AAcI;EACE,mBAAA;AAZN;AAcI;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,oBAAA;EACA,eAAA;EACA,UAAA;AAZN;AAgBE;EACE;IACE,gDAAA;EAdJ;AACF;AAiBE;EACE;IACE,qCAAA;EAfJ;AACF","sourcesContent":["@import '../../../styles/_variables';\r\n\r\n.finance-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n  margin-top: 20px;\r\n  &__row {\r\n    display: grid;\r\n    grid-template-columns: repeat(3, minmax(0, 1fr));\r\n    gap: 12px;\r\n  }\r\n\r\n  &__field {\r\n    &--select {\r\n      .finance-form__select-label {\r\n        position: relative;\r\n        display: block;\r\n      }\r\n    }\r\n  }\r\n\r\n  &__select-label {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 4px;\r\n    font-size: 13px;\r\n    letter-spacing: 1.1px;\r\n    color: #bbb7b7;\r\n  }\r\n\r\n  &__select-text {\r\n    position: absolute;\r\n    left: 23px;\r\n    top:3px;\r\n    font-size: 13px;\r\n  }\r\n  &__type-tabs {\r\n    display: flex;\r\n    gap: 8px;\r\n    margin-bottom: 16px;\r\n  }\r\n\r\n  &__type-tab--active {\r\n    opacity: 1;\r\n    button,a{\r\n      background: #f4f4f4;\r\n     span{\r\n       color:#131313;\r\n     }\r\n    }\r\n  }\r\n\r\n  &__select {\r\n    width: 100%;\r\n\r\n    background: var(--primary-color);\r\n    background: transparent;\r\n    border-radius: 8.485px;\r\n    background: $main;\r\n    border: 1px solid #2B2B2B;\r\n    padding: 20px 50px 13px 23px;\r\n    color: #F4F4F4;\r\n    font-family: \"Roboto\", sans-serif;\r\n    font-size: 13px;\r\n    letter-spacing: 1.95px;\r\n    outline: none;\r\n    appearance: none;\r\n  }\r\n\r\n  &__actions {\r\n    display: flex;\r\n    gap: 12px;\r\n    margin-top: 4px;\r\n  }\r\n\r\n  &__cancel {\r\n    opacity: 0.8;\r\n  }\r\n  &__purchase-amount {\r\n    position: relative;\r\n\r\n    input {\r\n      padding-right: 56px;\r\n    }\r\n    &-currency {\r\n      position: absolute;\r\n      right: 12px;\r\n      top: 50%;\r\n      transform: translateY(-50%);\r\n      pointer-events: none;\r\n      font-size: 12px;\r\n      z-index: 1;\r\n    }\r\n  }\r\n\r\n  @media (max-width: 1024px) {\r\n    &__row {\r\n      grid-template-columns: repeat(2, minmax(0, 1fr));\r\n    }\r\n  }\r\n\r\n  @media (max-width: 600px) {\r\n    &__row {\r\n      grid-template-columns: minmax(0, 1fr);\r\n    }\r\n  }\r\n}\r\n","$main: var(--primary-color);\r\n$accent:  var(--accent-color);\r\n$additional: var(--additional-color);\r\n$primary: #131313;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
